<app-table
    dataKey="id"
    [translatePrefix]="prefix"
    [columns]="columns"
    [items]="items()"
    [hideCheckboxes]="true"
    [showSearchBar]="false"
    [showCreate]="canCreate()"
    [showDetail]="canUpdate()"
    [showDelete]="canDelete()"
    (createCallback)="openUpsertDialog()"
    (detailCallback)="openUpsertDialog($event)"
    (deleteCallbackWithEvent)="deleteDiscount($event)"
>
    <ng-template pTemplate="discountPercentage" let-item="item">{{ item.discountPercentage }} %</ng-template>
</app-table>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonVisibility]="false"
        (secondaryClickEvent)="close()"
    ></app-action-buttons>
</div>
